// extracted by mini-css-extract-plugin
module.exports = {"shopByWrapper":"_25cd100f","itemsWrapper":"_a3e179b6"};